<div class="mb-4">
  @if (countryList$ | async; as countryList) {
    <p-select
      optionLabel="name"
      filterBy="name"
      [styleClass]="'w-full'"
      [options]="countryList"
      [appendTo]="'body'"
      [filter]="true"
      [filterPlaceholder]="'Start typing' | translate"
      placeholder="{{ 'Select one' | translate }}"
      [optionValue]="'id'"
      [formControl]="countryFormControl">
      <ng-template #selectedItem let-selectedCountry>
        @if (selectedCountry) {
          <div class="country-item-value-mod">
            @if (selectedCountry?.iso_code) {
              <img
                src="/assets/images/blocks/flag/flag_placeholder.png"
                [class]="'flag flag-' + selectedCountry.iso_code.toLowerCase()" />
            }
            <div class="ml-1">{{ selectedCountry.name | translate }}</div>
          </div>
        }
      </ng-template>
      <ng-template #item let-country>
        <div class="country-item-value-mod">
          @if (country?.iso_code) {
            <img
              src="/assets/images/blocks/flag/flag_placeholder.png"
              [class]="'flag flag-' + country.iso_code.toLowerCase()" />
          }
          <div class="ml-1">{{ country.name | translate }}</div>
        </div>
      </ng-template>
    </p-select>
  }
</div>

<offconon-state-province-dropdown
  [countryId]="countryFormControl.value"
  [selectedId]="stateFormControl.value"
  [stateFormControl]="stateFormControl" />
